var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"float-right d-none d-sm-block"},[_c('b',[_vm._v("Version")]),_vm._v(" 3.2.0 ")]),_c('strong',[_vm._v(" Copyright © 2014-2021 "),_c('a',{attrs:{"href":"https://adminlte.io"}},[_vm._v("AdminLTE.io")]),_vm._v(" . ")]),_vm._v(" All rights reserved. ")])
}]

export { render, staticRenderFns }